import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';

/** Mirror of backend `ActionCenterPrefDTO`: the Action Center card keys the caller hid. Empty = nothing hidden. */
export interface ActionCenterPrefResponse {
    hiddenKeys: string[];
}

/** The caller's own hidden Action Center cards, saved on the server per user and institution. */
export const ActionCenterPrefService = {
    get: async (institutionId: string): Promise<ActionCenterPrefResponse> => {
        const res = await axios.get(ENDPOINTS.DASHBOARD.ACTION_CENTER_PREF(institutionId), { headers: AuthService.getAuthHeader() });
        return res.data;
    },

    save: async (institutionId: string, hiddenKeys: string[]): Promise<ActionCenterPrefResponse> => {
        const res = await axios.put(ENDPOINTS.DASHBOARD.ACTION_CENTER_PREF(institutionId), { hiddenKeys }, { headers: AuthService.getAuthHeader() });
        return res.data;
    },
};
